import { CALENDAR_LOCALE } from '../../services/constant';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import { finalize } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
var AbbDashboardComponent = (function () {
    function AbbDashboardComponent(apiService, router, translateService) {
        this.apiService = apiService;
        this.router = router;
        this.translateService = translateService;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.startDate = null;
        this.endDate = null;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.loading = false;
        this.totalItems = 0;
        this.tableData = [];
        // sellerDetails: SellerDetail[] = [];
        // sellerNames: string[] = [];
        // searchSeller: string;
        // searchingSeller: boolean = false;
        this.branchCode = [];
        this.searchingBranch = false;
        this.branchList = [];
        this.searchingOutlet = false;
        this.outletList = [];
    }
    AbbDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subs = this.translateService.onLangChange.subscribe(function () {
            _this.clear();
            _this.loadInput();
            _this.search();
        });
        this.loadInput();
        this.search();
    };
    AbbDashboardComponent.prototype.loadInput = function () {
        this.calendarLocale = this.translateService.currentLang === 'en'
            ? CALENDAR_LOCALE.EN
            : CALENDAR_LOCALE.TH;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        // this.loadSeller();
        this.loadBranch();
        this.loadOutlet();
    };
    Object.defineProperty(AbbDashboardComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbbDashboardComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    AbbDashboardComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    AbbDashboardComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    AbbDashboardComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    AbbDashboardComponent.prototype.search = function (resetPageNumber) {
        var _this = this;
        if (resetPageNumber === void 0) { resetPageNumber = true; }
        if (resetPageNumber) {
            this.currentPage = 1;
        }
        var params = new HttpParams()
            .set('abb_no', this.abbNo || '')
            .set('issue_dt_after', moment(this.startDate).format('YYYY-MM-DD'))
            .set('issue_dt_before', moment(this.endDate).format('YYYY-MM-DD'))
            .set('page', this.currentPage.toString())
            .set('page_size', this.itemsPerPage.toString());
        // if (this.searchSeller) {
        //   params = params.set('company', this.searchSeller);
        // }
        if (this.searchBranch) {
            params = params.set('branch_code', this.searchBranch);
        }
        if (this.searchOutlet) {
            params = params.set('outlet', this.searchOutlet);
        }
        this.loading = true;
        this.apiService.getAbbData(params).subscribe(function (response) {
            _this.loading = false;
            _this.tableData = response.results;
            _this.totalItems = response.count;
        }, function (error) {
            _this.loading = false;
            console.error(error);
        });
    };
    AbbDashboardComponent.prototype.clear = function () {
        // this.searchSeller = null;
        this.searchBranch = null;
        this.searchOutlet = null;
        this.abbNo = null;
        this.outlet = null;
        this.loadInput();
        this.search();
    };
    AbbDashboardComponent.prototype.pageChanged = function () {
        this.search(false);
    };
    AbbDashboardComponent.prototype.optionChanged = function () {
        this.search();
    };
    AbbDashboardComponent.prototype.gotoDocumentIssue = function (data) {
        this.router.navigate(['document', 'issue'], { queryParams: { abbData: data.id } });
    };
    AbbDashboardComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    // loadSeller() {
    //   this.loading = true;
    //
    //   this.apiService.getSellerBranch()
    //     .pipe(
    //       finalize(() => {
    //         this.loading = false;
    //       })
    //     )
    //     .subscribe(
    //       (res: SellerDetail[]) => {
    //         this.sellerDetails = res;
    //
    //         this.setSellerNames();
    //       }
    //     );
    // }
    AbbDashboardComponent.prototype.loadBranch = function () {
        var _this = this;
        this.loading = true;
        this.apiService.getBranch()
            .pipe(finalize(function () { _this.loading = false; }))
            .subscribe(function (res) {
            _this.branchList = res.map(function (branch) { return ({
                branch_code: branch.code,
                full_name: branch.full_name
            }); });
            _this.setBranch(_this.branchList);
        }, function (error) {
            console.error('Error fetching branch data', error);
        });
    };
    AbbDashboardComponent.prototype.loadOutlet = function () {
        var _this = this;
        this.loading = true;
        this.apiService.getABBOutletDropdown()
            .pipe(finalize(function () {
            _this.loading = false;
        }))
            .subscribe(function (res) {
            for (var i = 0; i < res.length; i++) {
                _this.outletList.push(res[i].outlet);
            }
            _this.setOutlet(_this.outletList);
        }, function (error) {
            console.error('Error fetching outlet data', error);
        });
    };
    // setSellerNames() {
    //   if (this.translateService.currentLang === 'en') {
    //     this.sellerNames = this.sellerDetails.map(seller => seller.name_en);
    //   } else {
    //     this.sellerNames = this.sellerDetails.map(seller => seller.name_th);
    //   }
    //   this.sellerNames = this.sellerNames
    //     .filter((value, index, array) => array.indexOf(value) === index);
    // }
    AbbDashboardComponent.prototype.setBranch = function (branchData) {
        this.branchCode = branchData.filter(function (value, index, array) {
            return array.findIndex(function (branch) { return branch.branch_code === value.branch_code; }) === index;
        });
    };
    AbbDashboardComponent.prototype.setOutlet = function (outletData) {
        this.outlet = outletData.filter(function (value, index, array) {
            return array.indexOf(value) === index;
        });
    };
    return AbbDashboardComponent;
}());
export { AbbDashboardComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/abb-dashboard/abb-dashboard.component.ts.pre-build-optimizer.js